import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Pagination, StatusCode } from '../constants';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})

export class ProblemService {
  constructor(private commonService: CommonService) { }

  getAll(id: number,pageIndex: number = Pagination.PageIndex, pageSize: number = Pagination.PageSize, langId: string = ''): Observable<ResponseResult> {
    return this.commonService.getAll(`problem/by-user-group/${id}`, false, pageSize, pageIndex, langId);
  }

  create(model): Observable<ResponseResult> {
    return this.commonService.createData(`problem`, model, model.langId, model.parentId);
  }

  update(model): Observable<ResponseResult> {
    return this.commonService.updateData(`problem/${model.id}`, model);
  }

  delete(id): Observable<ResponseResult> {
    return this.commonService.deleteData(`problem/${id}`);
  }

  getById(id): Observable<ResponseResult> {
    return this.commonService.getById(`problem/${id}/detail`);
  }

}
